import { Dispatch, SetStateAction, createContext, useEffect, useState } from 'react';

import { getEvent } from '../services/EventService';

type ApplicationContextProps = {
    eventId: string;
    eventView: string;
    ticketCategory: string;
};

type ApplicationContextProviderProps = {
    children: React.ReactNode;
    props: ApplicationContextProps
};

type ApplicationContextType = {
    eventItem: any,
    setEventItem: Dispatch<SetStateAction<any>>,
    eventId: string,
    eventView: string,
    currentView: string,
    setCurrentView: Dispatch<SetStateAction<string>>,
    ticketCategory: string,
    currentTicket: any,
    setCurrentTicket: Dispatch<SetStateAction<any>>,
    workshopTickets: any,
    setWorkshopTickets: Dispatch<SetStateAction<any>>
};

export const ApplicationContext = createContext({} as ApplicationContextType);

export const ApplicationContextProvider = ({ children, props }: ApplicationContextProviderProps) => {
    const [eventItem, setEventItem] = useState({});

    const { eventId, eventView, ticketCategory } = props;

    const defaultView: string = 'eventViewDetail';
    const [currentView, setCurrentView] = useState<string>(defaultView);

    const [currentTicket, setCurrentTicket] = useState();

    const [workshopTickets, setWorkshopTickets] = useState();

    useEffect(() => {
        // console.info(`ApplicationContextProvider eventId: ${eventId} eventView: ${eventView}`);

        if (eventId !== '') {
            const fetchEvent = async () => {
                try {
                    const event = await getEvent(eventId);
                    setEventItem(event);
                } catch (error) {
                    console.error(error);
                }
            };

            fetchEvent();
        }
    }, []);

    useEffect(() => {
        if (Object.keys(eventItem).length === 0) return;

        const nextView = window.location.href.includes('confirm')
            ? 'registrationViewConfirm'
            : eventView;

        setCurrentView(nextView);
    }, [eventItem]);

    return (
        <ApplicationContext.Provider value={{ eventItem, setEventItem, eventId, eventView, currentView, setCurrentView, ticketCategory, currentTicket, setCurrentTicket, workshopTickets, setWorkshopTickets }}>
            {children}
        </ApplicationContext.Provider>
    );
};